const BxfToggleConstants = {
    CIRCLE: 'bxf-toggle__circle',
    SLIDER: 'bxf-toggle__slider',
    CIRCLE_SMALL: 'bxf-toggle__circle--small',
    SLIDER_SMALL: 'bxf-toggle__slider--small',
    TOGGLE: 'bxf-toggle',
    TOGGLE_GROUP: 'bxf-toggle--group',
    TOGGLE_FOOTER: ' bxf-toggle bxf-toggle__footer',
    TOGGLE_FOOTER_LABEL: 'bxf-toggle__label--footer ',
    TOGGLE_FOOTER_SLIDER: 'bxf-toggle__slider--footer',
    TOGGLE_FOOTER_CIRCLE: 'bxf-toggle__circle--footer',
    TOGGLE_VALIDATION_ERROR: 'bxf-toggle__validation--error',
    TOGGLE_VALIDATION_WARNING: 'bxf-toggle__validation--warning',
    TRANSFER: 'bxf-toggle__transfer',
    LABEL: 'bxf-toggle__label',
    LABEL_COMPACT: 'bxf-toggle__label--compact',
    LABEL_SMALL: 'bxf-toggle__label--small',
    LABEL_BOLD: 'bxf-toggle__label--bold',
    LABEL_DISABLED: 'bxf-toggle__label--disabled',
    LABEL_READONLY: 'bxf-toggle__label--readonly',
    CHECKMARK: 'checkmark',
    PARENT: 'parent',
    SWITCH: 'switch',
    TYPE: 'checkbox',
    INPUT_SUFFIX: '-input',
    REGULAR: 'regular',
    SMALL: 'small',
};

export { BxfToggleConstants as B };
